export default __webpack_public_path__ + "static/media/shift2DC.4091e3b5.png";